export const formatPercentage = new Intl.NumberFormat('en-US', {
  style: 'percent',
  minimumFractionDigits: 1,
  trailingZeroDisplay: 'stripIfInteger',
});

export const formatValue = new Intl.NumberFormat('en-US');

export const formatCompact = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  compactDisplay: 'short',
  maximumFractionDigits: 1,
});
